import { Component, OnInit } from '@angular/core';
import { CampaignManagerOffersModel, CampaignV2OffersQuery, CampaignV2OffersService } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'fgb-campaigns-v2-used-offers-list',
  templateUrl: './campaigns-v2-used-offers-list.component.html',
  styleUrls: ['./campaigns-v2-used-offers-list.component.scss'],
})
export class CampaignsV2UsedOffersListComponent implements OnInit {
  expiredOffers$: Observable<CampaignManagerOffersModel>;

  constructor(
    private campaignV2OffersService: CampaignV2OffersService,
    private campaignV2OffersQuery: CampaignV2OffersQuery
  ) {}

  ngOnInit() {
    firstValueFrom(this.campaignV2OffersService.fetchV2Offers());
    const now = new Date();
    this.expiredOffers$ = this.campaignV2OffersQuery.selectFirst().pipe(
      map((data) => ({
        Offers: data?.Offers?.filter((o) => new Date(o.DisplayUntilDate) < now) ?? [],
        Vouchers: data?.Vouchers?.filter((v) => new Date(v.DisplayUntilDate) < now) ?? [],
      }))
    );
  }
}
